import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import IntroductionCards, { IntroductionCardType } from './components/IntroductionCards';
import { useGlobal } from '@/utils/useGlobal';

export default function TheComp() {
    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.RealStories');

    const list: IntroductionCardType[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732182173381/RealStories-img3.jpg',
            headImg: 'https://websiteoss.ecoflow.com/upload/image/1732182172676/RealStories-head3.jpg',
            desc: t('card1_desc'),
            userName: t('card1_name'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732182172960/RealStories-img1.jpg',
            headImg: 'https://websiteoss.ecoflow.com/upload/image/1732182172486/RealStories-head2.jpg',
            desc: t('card2_desc'),
            userName: t('card2_name'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732182173159/RealStories-img2.jpg',
            headImg: 'https://websiteoss.ecoflow.com/upload/image/1732182172438/RealStories-head1.jpg',

            desc: t('card3_desc'),
            userName: t('card3_name'),
        },
    ];
    return (
        <div className={styles.TheComp} id={PageNavType.Endorsement}>
            <EfSpec />
            <EfSection className="real-stories-section" hasAnimation={false} title={t('title')} desc={t('desc')} />
            <IntroductionCards list={list} />
            <EfSpec />
        </div>
    );
}
